<template>
  <div class="searchContainer">
    <div class="topView">
      <el-form
        ref="formTool"
        label-width="82px"
        :model="formTool"
        :inline="true"
        size="small"
      >
        <el-row style="display: flex; margin-top: 16px">
          <el-form-item label="" prop="name">
            <el-input v-model="formTool.name" placeholder="请输入关键词" />
          </el-form-item>
          <el-form-item label="" label-width="120px" prop="date">
            <el-date-picker
              v-model="formTool.date"
              value-format="yyyy-MM-dd"
              type="daterange"
              size="small"
              range-separator="-"
              :picker-options="pickerOptions"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              style="width: 100%;"
            />
          </el-form-item>
          <div class="btn-box">
            <el-button type="primary" size="small" @click="getList(1)">查 询</el-button>
            <el-button  size="small" @click="handleReset"> 重 置 </el-button>
            <el-button type="primary" size="small" style="float: right" @click="handleKeywordsLimit">
              关键词屏蔽
            </el-button>
            <!-- <el-button size="small" type="primary" style="float: right" @click="handleExport">
              导出
            </el-button> -->
          </div>
        </el-row>
      </el-form>
      <div
        class="center"
        :style="contentHeight ? `height:${contentHeight}px!important` : ''"
      >
        <MyTable
          :table-data="tableData"
          :index="index"
          :selection="selection"
          :page="page"
          :operation="operation"
          :table-option.sync="tableOption"
          @page-change="getList"
          v-loading='listLoading'
        >
          <template slot="clik_cvr" slot-scope="scope">
            {{scope.row.clik_cvr ? parseFloat((scope.row.clik_cvr * 100)).toFixed(4) + '%' : ''}}
          </template>
          <template slot="status" slot-scope="scope">
            <div class="action-row">
              <el-link
              :underline="false"
              style="margin-left: 16px"
              type="primary"
              class="btn"
              @click="handleDetail(scope.row)"
              >搜索趋势</el-link
            >
            <el-link
              :underline="false"
              style="margin-left: 16px"
              type="primary"
              class="btn"
              @click="handleDistributionDetail(scope.row)"
              >推荐分布</el-link
            >
            </div>
          </template>
        </MyTable>
      </div>
    </div>
    <SearchDetailDlg ref="searchDetail" />
    <DistributionDlg ref="distribution" />
    <KeyWordsDlg ref="keyWords" @close="getList"></KeyWordsDlg>
  </div>
</template>

<script>
import MyTable from "@/components/myTable";
import SearchDetailDlg from "./dialog/searchDetail";
import DistributionDlg from "./dialog/distribution-detail";
import KeyWordsDlg from "./dialog/keywords-detail";

import { queryGoodsSalesEcharts, excelExport } from "@/api/statistics";
import close from '@/assets/login/close-eyes.png';

export default {
  components: { MyTable, SearchDetailDlg,DistributionDlg ,KeyWordsDlg},
  data() {
    return {
      operation: false,
      selection: false,
      index: false,
      formTool: {
        name: "",
        date: [],
      },
      contentHeight: 0,
      tableData: [],
      tableOption: [
        { label: "关键词", prop: "keyword" },
        {
          label: "搜索数/搜索人数",
          prop: "search_cnt",
          customHeader: "true",
          content: "数据来源：APP+PC搜索",
        },
        {
          label: "关联SKU数量",
          prop: "sku_cnt",
          customHeader: "true",
          content: "1. 对每个用户每次搜索后的搜索结果去重后的SKU数；2. 当次搜索用户浏览的分页结果数量",
        },
        {
          label: "关联商户数",
          prop: "shop_cnt",
          customHeader: "true",
          content: "关联SKU去重后商户数",
        },
        {
          label: "点击量",
          prop: "click_cnt",
          customHeader: "true",
          content: "点击量：搜索结果页各SKU的点击次数合计",
        },
        {
          label: "总销量",
          prop: "qty",
          customHeader: "true",
          content: "在筛选时间内的SKU总销量",
        },
        // {
        //   label: "点击转化率",
        //   prop: "clik_cvr",
        //   customHeader: "true",
        //   content: "点击转化率=点击量/SKU推荐量*100%",
        //   slot: true
        // },
        { label: "操作", prop: "status", slot: true, width: "180px", align: 'center' },
      ],
      page: {
        total: 0,
        current: 1,
        size: 30,
        pageSizes: [30, 50, 100, 500],
      },
      type: 119,//
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      listLoading: false
    };
  },
  created() {
    this.handleReset()
    this.getList();
  },
  updated() {
    this.getWindowView();
  },
  methods: {
    getWindowView() {
      let innerHeight = window.innerHeight; //获取页面高度
      let headHeight = 60;
      headHeight = this.$refs["formTool"].$el.clientHeight; //获取子页面head 高度
      let contentHeight = innerHeight - 250 - headHeight;
      this.contentHeight = contentHeight;
    },
    // 获取请求参数
    getParam() {
       // [关键词,关键词,开始时间,开始时间,结束时间,结束时间,每页行数,第几行开始]
      const date1 = this.correctData(this.formTool.date[0]).replace(/-/g, '')
      const date2 = this.correctData(this.formTool.date[1]).replace(/-/g, '')
      return [this.correctData(this.formTool.name), this.correctData(this.formTool.name),
        date1, date1, date2, date2,date1, date1, date2, date2,
        this.page.size, (this.page.current - 1) * 30]
    },
    getList(current) {
      if (current) {
        this.page.current = current;
      }

      let list = this.getParam()
      this.getTotal(list)
      this.getTable(list)
    },
    // 请求表格数据升序/降序
    getTable(list) {
      const param = {
        params: list,
        type: this.type
      }
      this.listLoading = true
      queryGoodsSalesEcharts(param).then((res) => {
        if (res) {
           res.forEach(item => {
            item.search_cnt = `${item.search_cnt}/${item.operator_cnt}`
          })
          this.tableData = res;
        } else {
          this.tableData = [];
        }
      }).finally(() => this.listLoading = false)
    },
    // 请求总数
    getTotal(list) {
      const param = {
        params: list,
        type: 118
      }
      queryGoodsSalesEcharts(param).then((res) => {
        if (res) {
          this.page.total = Number(res[0].cnt);
        } else {
          this.page.total = 0;
        }
      });
    },
    // 格式化数据
    correctData(data) {
      return data || ''
    },
    handleReset() {
      this.$refs.formTool && this.$refs.formTool.resetFields();
      this.formTool.date = []
      const endData = new Date()
      endData.setDate(new Date().getDate() - 6)
      this.formTool.date.push(this.formatDate(endData))
      this.formTool.date.push(this.formatDate(new Date()))
    },
    //格式化日期：yyyy-MM-dd
    formatDate(date) {
      const myyear = date.getFullYear();
      let mymonth = date.getMonth() + 1;
      let myweekday = date.getDate();
      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      return (myyear + "-" + mymonth + "-" + myweekday);
    },
    handleExport() {
      const list = this.getParam()
      list.pop()
      list.pop()
      const param = {
        type: 111,
        params: list
      }
      excelExport(param).then((res) => {
      });
    },
    handleDetail(row) {
      this.$refs.searchDetail.init(row);
    },
    //趋势分布
    handleDistributionDetail(row) {
      this.$refs.distribution.init(row);
    },
    // 关键词屏蔽
    handleKeywordsLimit(){
      this.$refs.keyWords.init();
    }
  },
};
</script>

<style lang="scss" scoped>
.searchContainer {
  height: 100%;
  background-color: #fff;
  padding: 12px;
  border-radius: 4px;
  .btn-box {
    margin-left: 12px;
    flex: 1;
  }
  .center {
    border-top: 1px solid #f2f2f2;
    padding-top: 12px;
  }
  .action-row {
    display: flex;
    align-items: center;
  }
}
</style>
